import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';
import { TaxAccountingPropTypes } from '../../shared/propTypes/taxAccounting';

import {
  sharedActions,
} from './store/actions';

class TaxAccountingSettingsAdminColumnRenderer extends PureComponent {
  static propTypes = {
    value: TaxAccountingPropTypes.isRequired,
    showTaxAccountingSettingsModalForEdit: PropTypes.func.isRequired,
    showTaxAccountingSettingsModalForDelete: PropTypes.func.isRequired,
    rowIndex: PropTypes.number.isRequired,
  };

  showTaxAccountingSettingsModalForEdit = () => {
    const { value, showTaxAccountingSettingsModalForEdit } = this.props;
    showTaxAccountingSettingsModalForEdit(value);
  };

  showTaxAccountingSettingsModalForDelete = () => {
    const { value, showTaxAccountingSettingsModalForDelete, rowIndex } = this.props;
    showTaxAccountingSettingsModalForDelete({ entity: value, rowIndex });
  };

  render() {
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Tax Accounting Settings"
          onClick={this.showTaxAccountingSettingsModalForEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Delete Tax Accounting Settings"
          onClick={this.showTaxAccountingSettingsModalForDelete}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

export default connect(
  null,
  {
    showTaxAccountingSettingsModalForEdit: sharedActions.showModalForAddEdit,
    showTaxAccountingSettingsModalForDelete: sharedActions.showModalForRemove,
  }
)(TaxAccountingSettingsAdminColumnRenderer);
